export const environment = {
    production: false,
    // DEV ENVIRONMENT
    apiBaseUrl: 'https://stage.hezky.ai/admin/api/',
    authBaseUrl: 'https://stage.hezky.ai/auth/',
    customerApiBaseUrl: 'https://stage.hezky.ai/customer/',
    userApiBaseUrl: 'https://stage.hezky.ai/user/',
    logsUrl: 'https://stage.hezky.ai/device/',

    // LOCAL ENVIRONMENT 
    // apiBaseUrl: 'http://localhost:9000/api/',
    // authBaseUrl: 'http://localhost:5191/',
    // customerApiBaseUrl: 'http://localhost:3113/',
    // userApiBaseUrl: 'http://localhost:3117/',
    // logsUrl: 'http://localhost:3333/',

    loginSuccess: '/customer',
    loginFailure: '/login',
};
